
<div class="kt-header__topbar">
	<div class="cyrixlogo"></div>
	<!-- <kt-notification  class="user-notifications" [skin]="'dark'" [icon]="'fas fa-bell custon-iconic'"></kt-notification> -->
	<!-- <kt-user-profile></kt-user-profile> -->

</div>
